<template>
  <li class="wf-flex wf-justify-between wf-py-1">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Full width</span>
    <div>
      <toggle-button sync v-model="fullwidth"/>
    </div>
  </li>
</template>

<script>
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      fullwidth: {
        get() {
          return !! this.elementClasses(this.classes)[this.device].find(constant => constant.value == 'WIDTH_FULL')
        },
        set(value) {
          console.log(value)
          if (value) {
            return this.addToArray(this.module, [{property: 'Width', value: 'WIDTH_FULL', touched: false}], this.classes, this.device, {}, true, this.parentModule)
          }
          return this.addToArray(this.module, [{property: 'Width', value: 'WIDTH_AUTO', touched: false}], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>